var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('callTestResultsTable',{attrs:{"sharedLinkView":true,"callTestRequest":_vm.broadcast,"liveDataResults":_vm.liveDataResults,"numberOfCalls":_vm.number_of_calls,"testFinalStatus":_vm.testFinalStatus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }